import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import apiSubscription from 'common/api/subscription';

import reducers from './reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));

apiSubscription(store);

export default store;
